import * as React from 'react';
import { graphql } from 'react-relay';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import TableStatus from '../common/TableStatus';
import TableButton from '../common/buttons/TableButton';
import { doGenerateInvoice, viewInvoice } from './renderUtils';
import { doCommitPromise } from '../../common/commit';
import emailTradeInvoiceMutation from '../../mutations/EmailTradeInvoiceMutation';
import mvMutationErrors from '../../common/errorReport';
import notiStack from '../../common/notiStack';

function StockOrderInvoiceActions(props) {
  const {
    stockOrder: node,
    justifyButtons,
  } = props;
  if (!node) return null;
  const invoiceGenerated = (node.tradeInvoice !== null) && (node.tradeInvoice !== undefined);
  const hasPortfolioInvoice = invoiceGenerated && (node.tradeInvoice.portfolioOrder !== null);
  const clientAccount = node.account.clientaccount;
  const forShareSalesAccount = clientAccount && clientAccount.accountType === 'SSD';
  const matched = (node.quantityToDate === node.quantity);
  const hasError = invoiceGenerated && (node.tradeInvoice.state === 'ERR');
  const viewButtonStyle = {
    color: hasError ? 'secondary' : 'default',
  };

  const itemKey = `${node.id}-${node.updatedAt}`;
  const invoiceItemKey = node.tradeInvoice ? `${node.tradeInvoice.id}-${node.tradeInvoice.updatedAt}` : itemKey;

  let invoiceType = 'Stock';
  if (forShareSalesAccount) {
    invoiceType = 'SSD';
  } else if (hasPortfolioInvoice) {
    invoiceType = 'Portfolio';
  }

  return (
    <Grid container spacing={1} justify={justifyButtons}>
      {
        !invoiceGenerated && matched && (
          <>
            <Grid item style={{ 'padding-top': '6px' }}>
              <TableStatus color="primary">
                { invoiceType }
              </TableStatus>
            </Grid>

            { !forShareSalesAccount && (
              <Grid item>
                <TableButton
                  color="primary"
                  onClickPromise={() => doGenerateInvoice(null, node.id)}
                >
                  Generate
                </TableButton>
              </Grid>
            )}
          </>
        )
      }

      {
        invoiceGenerated && matched && (
          <>
            <Grid item style={{ 'padding-top': '6px' }}>
              <TableStatus color="primary">
                { invoiceType }
              </TableStatus>
            </Grid>
            <Grid item>
              <TableButton
                key={invoiceItemKey}
                onClick={viewInvoice(node)}
                disabled={hasError}
                {...viewButtonStyle}
              >
                View
              </TableButton>
            </Grid>

            { !forShareSalesAccount && (
              <>
                <Grid item>
                  <TableButton
                    key={itemKey}
                    color="primary"
                    onClickPromise={() => doGenerateInvoice(null, node.id)}
                  >
                    Regenerate
                  </TableButton>
                </Grid>

                <Grid item>
                  <TableButton
                    key={invoiceItemKey}
                    color="primary"
                    onClickPromise={() => doCommitPromise(
                      emailTradeInvoiceMutation,
                      {
                        tradeInvoiceId: node.tradeInvoice.id,
                      },
                      (response) => {
                        if (!mvMutationErrors(response, 'emailTradeInvoice')) {
                          notiStack.success('Email sent');
                        }
                      },
                      () => null,
                    )}
                    disabled={hasError}
                  >
                    e-mail
                  </TableButton>
                </Grid>
              </>
            )}
          </>
        )
      }

    </Grid>
  );
}

StockOrderInvoiceActions.propTypes = {
  stockOrder: PropTypes.object.isRequired,
  justifyButtons: PropTypes.string,
};

StockOrderInvoiceActions.defaultProps = {
  justifyButtons: 'center',
};

graphql`
  fragment StockOrderInvoiceActions_invoice on StockOrderNode {
    tradeInvoice {
      id
      pdfUrl
      pdf
      state
      createdAt
      updatedAt
      portfolioOrder {
        id
      }
    }
  }
`;

export default StockOrderInvoiceActions;
